import { MedisanteDevice } from '../../../../pages/Device/types';
import { FunctionComponent, useState } from 'react';
import ConfirmationDialog from '../../../../eliot-components/src/ConfirmationDialog/ConfirmationDialog';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';
import { useDeleteDeviceMutation } from '../../../../store/api-slice';

interface Props {
  devices: MedisanteDevice[];
  isOpen: boolean;

  onClose?(): void;
  onCompleted?(errors: string[]): void;
}

const DeleteDevice: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  onCompleted,
  devices,
}) => {
  const config = useConfig();
  const [loading, setLoading] = useState(false);
  const [deleteDevice] = useDeleteDeviceMutation();

  let noDelete = false;
  const noDeleteError = [];

  if (devices.length === 1) {
    if (devices[0].measurementCount && devices[0].measurementCount !== 0) {
      noDelete = true;
      noDeleteError.push(`${devices[0].measurementCount} measurements`);
    }
    if (devices[0].targetSystems.length > 0) {
      noDelete = true;
      noDeleteError.push(`${devices[0].targetSystems.length} target systems`);
    }
  } else {
    const devicesWithMeasurements = devices.filter(
      (d) => d.measurementCount && d.measurementCount !== 0
    );
    if (devicesWithMeasurements.length > 0) {
      noDeleteError.push(`measurements`);
      noDelete = true;
    }

    const devicesWithTs = devices.filter((d) => d.targetSystems.length > 0);
    if (devicesWithTs.length > 0) {
      noDeleteError.push(`webhooks`);
      noDelete = true;
    }
  }

  return (
    <div>
      <ConfirmationDialog
        isOpen={isOpen}
        onClose={onClose}
        noCloseOnConfirm={true}
        onConfirm={async () => {
          const errors = Array<string>();
          setLoading(true);
          for (const dev of devices) {
            const resp: any = await deleteDevice({
              id: dev.id,
              apiBaseURL: config.apiBaseURL,
            });
            if (resp.error) {
              errors.push(`${dev.id}: ${resp.error.message}`);
            }
          }
          setLoading(false);
          onCompleted && onCompleted(errors);
        }}
        disabled={loading || noDelete}
        isLoading={loading}
        warningColor={'warning'}
        warningText={
          noDelete
            ? `Device cannot be deleted because it has ${noDeleteError.join(
                ' and '
              )}`
            : ''
        }
        questionText={
          noDelete
            ? ''
            : `Are you sure you want to delete this ${
                devices.length === 1 ? 'device' : 'devices'
              }?`
        }
        confirmationText="Confirm"
        cancelText="Cancel"
        title={`Delete ${devices.length === 1 ? 'device' : 'devices'}`}
      />
    </div>
  );
};

export default DeleteDevice;
